var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOrganizationCenter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#001B49",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16 L24,36 L13,36 L13,35 L19,35 L19,18.5 L16.528,17.573 L24,16 Z M24,15 L14.82,16.933 L13,16.25 L13,13.895 L24,11 L24,15 Z M24,10 L13,12.895 L13,10 L24,6.5 L24,10 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0.7,
    fill: "#FFF",
    points: "29 19 34 18.5 34 34 29 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,18.579 L11,35 L6,34 L6,19.763 L11,18.579 Z M11,15.5 L11,17.579 L6,18.763 L6,16.5 L11,15.5 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 20,
    cy: 20,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1987798,33.0004574 C31.5306204,37.2848477 26.0823891,40 20,40 C13.9176109,40 8.46937959,37.2848477 4.8012202,33.0004574 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 20,
    cy: 20,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#001B49",
    strokeWidth: 1.5,
    cx: 20,
    cy: 20,
    r: 19.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrganizationCenter);
export default __webpack_public_path__ + "static/media/ic-organization-center.a316dd9f9d7f38adab3b8b7d993496f8.svg";
export { ForwardRef as ReactComponent };